import axios from "axios";

const adminApi = axios.create({
  baseURL: "http://localhost/Backend-SSQH/public/api/admin",
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default adminApi;